<!-- 登录框 -->
<template>
  <div class="popup_wrapper"
       :class="{'active': form_msg && form_msg.show}"
       @click="bind_hide_form">
    <div class="popup_form_wrapper"
         @click.stop>
      <div class="close"
           @click="bind_hide_form"><i class="el-icon-close"></i></div>
      <!-- 登录页头部 -->
      <div class="title_wrapper"
           v-show="type=='login'">
        <div class="title_en">LOGIN</div>
        <!-- <div class="title">登录</div> -->
      </div>
      <!-- 合作页头部 -->
      <div class="title_wrapper"
           v-show="type=='cooperation'">
        <div class="title_en">COOPERATION</div>
        <!-- <div class="title">申请合作</div> -->
      </div>
      <!-- 切换访客类型 -->
      <el-tabs @tab-click='bind_toggle_visitor_type'
               v-model='visitor_type'
               class="type_wrapper">
        <el-tab-pane label="Advertiser"
                     name="advertiser"></el-tab-pane>
        <el-tab-pane label="Developer"
                     name="developer"></el-tab-pane>
      </el-tabs>
      <!-- 登录页内容 -->
      <div class="login"
           v-show="type=='login'">
        <div id="urs-login-block"
             style='width: 420px;height: 213px;'></div>
        <div class="situation_wrapper">
          <div class="forget"
               @click="bind_jump(forget_url)">Forget password</div>
          <div class="register"
               @click="bind_jump(register_url)">Registration</div>
        </div>
      </div>
      <!-- 合作页内容 -->
      <div class="cooperation"
           v-show="type=='cooperation'">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 class="cooperation_form">
          <el-form-item prop="name">
            <el-input v-model="ruleForm.name"
                      placeholder="Name（required）"></el-input>
          </el-form-item>
          <el-form-item prop="tel">
            <el-input v-model="ruleForm.tel"
                      placeholder="Mobile phone (required)"></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <el-input v-model="ruleForm.email"
                      placeholder="Email or IM"></el-input>
          </el-form-item>
          <el-form-item prop="refer">
            <el-input v-model="ruleForm.refer"
                      placeholder="website/APP name"></el-input>
          </el-form-item>
          <el-form-item prop="Some_details">
            <el-input placeholder="Some details" type="textarea" v-model="ruleForm.details"></el-input>
          </el-form-item>
        </el-form>
        <div class="btn"
             @click="bind_submit_form">Submit</div>
        <div class="jump_login" v-if="visitor_type !== 'advertiser'">
          Existing accounts,<span @click="x('login')">Login immediately</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CONSTANT from '@/util/constant';
export default {
  props: ['form_msg'],
  watch: {
    // 弹窗的类型
    // 默认是申请合作
    form_msg (curVal) {
      this.type = curVal.form_type;
      // 如果在流量变现页打开表单页，默认以开发者身份操作
      if (this.$route.path.indexOf('flow_to_cash') > -1 || this.$route.path.indexOf('Publishers') > 1) {
        this.visitor_type = 'developer';
        this.bind_toggle_visitor_type();
      } else {
        this.visitor_type = 'advertiser';
        this.bind_toggle_visitor_type();
      }
    }
  },
  data () {
    var validateTel = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your mobile number'));
      } else if (!(/^(\+|00){0,2}(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/.test(value))) {
        callback(new Error('Please enter the correct mobile number'));
      } else {
        callback();
      }
    };
    return {
      // 弹窗的类型
      type: '',
      // 访客类型（默认广告主）
      visitor_type: 'advertiser',
      // 忘记密码链接地址
      forget_url: 'http://reg.163.com/resetpwd/index.do',
      // 免费注册链接地址
      register_url: 'https://xinzhixuan.youdao.com/zhixuanreg/',
      // 表单数据
      ruleForm: {

      },
      // 表单规则
      rules: {
        name: [
          { required: true, message: 'Please enter a name', trigger: 'blur' }
        ],
        tel: [
          { validator: validateTel, trigger: 'blur' }
        ],
        email: [{ required: true, message: 'Please enter Email or IM', trigger: ['blur', 'change'] }],
        refer: [{ required: true, message: 'Please enter website or APP', trigger: ['blur', 'change'] }]
      }
    };
  },
  mounted () {
    // 初始化登录组件
    if (window.URS) {
      this.urs = new window.URS({
        newCDN: 1,
        version: 3,
        isHttps: 1,
        product: 'search',
        promark: 'ZqGIaGq',
        host: 'youdao.com',
        mode: 'float',
        productKey: '52963008b399524b1c86c7a4ba745aec',
        cookieDomain: 'youdao.com',
        regCookieDomain: 'youdao.com',
        prdomain: '@163.com',
        page: 'login',
        loginText: '登录',
        includeBox: 'urs-login-block',
        placeholder: { account: '网易邮箱' },
        single: 1,
        notFastReg: 0,
        needanimation: 0,
        //cssDomain: 'https://c.youdao.com/dsp/website/header/',
        //cssFile: 'URS.css',
        style: `
                        .u-logo{display:none}
                        .m-unlogin{display:none} 
                        .m-footer{display:none} 
                        .m-header{display:none} 
                        .u-loginbtn{background: #FC754C !important;border-radius: 3px;font-size:16px;letter-spacing:10px;text-align:center}
                        .inputbox{background: #f7f9fc !important; border-radius: 4px;border-color:#f2f5fa !important;}
                        .j-inputtext{background: #f7f9fc;}
                        .pr-domain{background: #f7f9fc !important;}
                        `,
        logincb: function (username) {
          window.location.href = "https://xinzhixuan.youdao.com/login";
        }
      });
      this.urs.showIframe();
      this.urs.closeIframe();
    }
    if (document && !('placeholder' in document.createElement('input'))) {
      this.ruleForm = {
        name: '姓名（必填）',
        tel: '手机（必填）',
        email: 'QQ',
        refer: '推广网站/APP名称'
      }
    }
  },
  methods: {
    // 切换类型
    x (tag) {
      window.location.href = '/login'
    },
    bind_hide_form () {
      // 隐藏表单
      setTimeout(() => {
        this.form_msg.show = false;
      }, 100)
    },
    // 切换访客类型
    bind_toggle_visitor_type () {
      switch (this.visitor_type) {
        case 'advertiser':
          this.register_url = 'https://xinzhixuan.youdao.com/zhixuanreg/';
          this.urs.logincb = function () {
            window.location.href = " http://xinzhixuan.youdao.com/login";
          }
          break;
        case 'developer':
          this.register_url = 'https://zhixuan.youdao.com/devreg/';
          this.urs.logincb = function (username) {
            window.location.href = ` https://zhixuan.youdao.com/developer/login?fc=${username[0].toLowerCase()}`;
          }
          break;
        default:
          break;
      }
    },
    // 跳转
    bind_jump (url) {
      window.location.href = url;
    },
    // 提交表单信息
    bind_submit_form () {
      this.$refs.ruleForm.validate((valid) => {
        // 验证成功,提交表单
        if (valid) {
          let vals = [
            `name=${encodeURIComponent(this.ruleForm.name)}`,
            `phone=${encodeURIComponent(this.ruleForm.tel)}`,
            `email=${encodeURIComponent(this.ruleForm.email)}`,
            `reffer=${encodeURIComponent(this.ruleForm.refer)}`
            `details=${encodeURIComponent(this.ruleForm.details)}`
          ]
          let turl = `${CONSTANT.FORM_URL}&${vals.join('&')}`;
          (new Image()).src = turl;
          this.bind_hide_form();
          setTimeout(() => {
            this.$message({
              message: '提交成功',
              center: true,
              type: 'success',
              customClass: 'msg_center',
              duration: 1000
            })
          }, 500)
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style>
@keyframes show {
  0% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
/* 弹窗 */
.popup_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
  display: none;
}
.popup_wrapper.active {
  animation: 0.2s show linear;
  display: block;
}
/* 表单 */
.popup_form_wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  /* transform: translate(-50%, -50%); */
  margin-left: -210px;
  margin-top: -250px;
  width: 420px;
  /* height: 500px; */
  padding: 44px 0;
  background: #fff;
  border-radius: 4px;
}
/* 关闭按钮 */
.popup_form_wrapper .close {
  cursor: pointer;
  position: absolute;
  font-size: 20px;
  right: 48px;
  top: 44px;
  z-index: 999;
}
/* 标题 */
.popup_form_wrapper .title_wrapper {
  padding: 0 48px;
  position: relative;
  margin-bottom: 20px;
}
.popup_form_wrapper .title_wrapper .title_en {
  text-align: left;
  font-size: 40px;
  line-height: 40px;
  font-weight: bold;
  color: #f3f4f7;
}
.popup_form_wrapper .title_wrapper .title {
  position: absolute;
  top: 20px;
  left: 48px;
  font-size: 32px;
  color: #18253d;
  line-height: 32px;
  font-weight: bold;
}
/* 类型（广告主/开发者） */
.type_wrapper {
  padding: 0 48px;
  margin-bottom: 17px;
}
.type_wrapper .el-tabs__item {
  color: #aaadb3;
}
.type_wrapper .el-tabs__item.is-active {
  color: #292c33;
}
.type_wrapper .el-tabs__active-bar {
  background-image: linear-gradient(-90deg, #fc833c 0%, #fc754c 98%);
  background-color: #fc754c; /* ie9 */
}
/* 忘记密码/注册 */
.situation_wrapper {
  margin-top: 10px;
  padding: 0 68px;
  font-size: 12px;
  color: #aaadb3;
  line-height: 12px;
}
.situation_wrapper .forget {
  float: left;
  cursor: pointer;
}
.situation_wrapper .register {
  float: right;
  cursor: pointer;
}
.situation_wrapper .forget:hover,
.situation_wrapper .register:hover {
  text-decoration: underline;
}
/*  申请合作 */
.cooperation {
  padding: 0 48px;
}
.cooperation_form {
  overflow: hidden;
}
.cooperation_form .qq {
  float: left;
  width: 132px;
}
.cooperation_form .refer {
  float: right;
  width: 180px;
}
.cooperation_form .el-input__inner, .cooperation_form .el-textarea__inner {
  background: #f7f9fc;
  border: 1px solid #f2f5fa;
}
.cooperation .btn {
  padding: 0 48px;
  height: 42px;
  text-align: center;
  background-image: linear-gradient(-90deg, #fc833c 0%, #fc754c 98%);
  background-color: #fc754c; /* ie9 */
  font-size: 16px;
  line-height: 42px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
}
.cooperation .jump_login {
  text-align: center;
  font-size: 12px;
  color: #aaadb3;
  line-height: 12px;
  margin-top: 16px;
}
.cooperation .jump_login span {
  padding: 0 5px;
  color: #000;
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/PopUp.vue